import axios from 'axios'
import { SALVAR_FECHAMENTO_CAIXA } from '../../types'
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil'
import { URL } from '../../../util/ambienteActions';

export default function salvarFechamentoCaixa (codigoEmpresa, parametros) {
  const url = `${URL}/fechamento-caixa-usuario/empresa/${codigoEmpresa}/salvar`;
  return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: SALVAR_FECHAMENTO_CAIXA,
        payload: response
      })
  );
}
